import axios from '@/load_axios'
import { API_HOST } from '@/constants';
const pagesUrl = `${API_HOST}/wp-json/wp/v2/pages`

// The ACF layout textarea holds whatever an editor typed; state must always hold an array.
function parseLayout(post) {
    const raw = post.acf.layout
    if(Array.isArray(raw)) {
        return raw
    }
    try {
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
    } catch(e) {
        console.error(`Invalid page layout JSON for page ${post.id} (${post.slug}): ${raw} — ${e.message}`)
        return []
    }
}

const pages = {
    namespaced: true,
    state: {
        all: [],
        fetching: [],
    },
    getters: {
        category: (state) => (id) => {
            return state.all.filter(({categories}) => categories.includes(id))
        },
        children: (state) => (id) => {
            return state.all
                .filter(({parent}) => parent == id)
                .sort((a,b) => b.menu_order - a.menu_order)
        },
        childrenByName: (state) => (id) => {
            return state.all
                .filter(({parent}) => parent == id)
                .sort((a,b) => a.title.rendered.localeCompare(b.title.rendered))
        },
        id: (state) => (id) => {
            return state.all.find( page => page.id == id )
        },
        lastFromCategory: (state) => (categoryId) => {
            const pages = state.all.filter(({categories}) => categories.includes(categoryId))
            return pages.sort((a, b) => b.date - a.date)[0]
        },
        latestFromCategory: (state) => ({id, amount, offset}) => {
            let pages = []
            let skipped = 0
            for(let post of state.all) {
                if( skipped < offset ) {
                    skipped++
                    continue
                }
                if( pages.length == amount ) break
                if( !post.categories.includes(id) ) continue
                pages.push(post)
            }
            return pages
        },
        slug: (state) => (slug, path) => {
            return state.all.find( post => {
                let link = post.link
                if( link[link.length - 1] == "/" ) {
                    link = link.slice(0, link.length-1)
                }
                if( path[path.length - 1] == "/" ) {
                    path = path.slice(0, path.length-1)
                }
                return post.slug == slug && link == path
            })
        },
    },
    mutations: {
        add(state, pages) {
            for(let post of pages) {
                const index = state.all.findIndex( storedPost => storedPost.id === post.id)
                post.acf.layout = parseLayout(post)
                if(index === -1) {
                    state.all.push(post)
                } else {
                    state.all.splice(index, 1, post)
                }
            }
        },
        addOne(state, page) {
            const index = state.all.findIndex( stored => stored.id === page.id)
            page.acf.layout = parseLayout(page)
            if(index === -1) {
                state.all.push(page)
            } else {
                state.all.splice(index, 1, page)
            }
        },
        fetching(state, options) {
            state.fetching.push(options)
        }
    },
    actions: {
        async getAll({commit}) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/pages`)
            commit('add', res.data)
        },
        async getCategory({commit}, id) {
            const url = `${API_HOST}/wp-json/wp/v2/pages?categories=${id}`
            const res = await axios.get(url)
            commit('add', res.data)
        },
        async getChildren({commit, state}, id) {
            const exists = state.fetching.find(({param, value}) => param == 'parent' && value == id)
            if( exists ) {
                return
            }
            commit('fetching', {param: 'parent', value: id})
            let page = 0
            let totalPages = 1
            let pages = []
            do {
                page++
                let res = await axios.get(pagesUrl, {params: {
                    parent: id,
                    page,
                    order: 'asc',
                    per_page: 100,
                }})
                totalPages = res.headers['x-wp-totalpages']
                pages.push(...res.data)
            } while ( page < totalPages )
            commit('add', pages)
        },
        async getOne({commit}, params) {
            const res = await axios.get(`${pagesUrl}/${params.id}`, {params: params})
            commit('addOne', res.data)
        },
        async fetch({commit}, slug) {
            const res = await axios.get(pagesUrl, {params: {slug}})
            commit('add', res.data)
        },
    },
}

export default pages
